export function shouldResetReportsScopeOnBranchChange(
  prevBranchId: string | undefined,
  nextBranchId: string | undefined,
): boolean {
  if (prevBranchId === nextBranchId) return false;
  if (prevBranchId == null && nextBranchId != null) return false;
  return true;
}
